import { render, staticRenderFns } from "./SearchContainer.vue?vue&type=template&id=3c384db8&"
import script from "./SearchContainer.vue?vue&type=script&lang=ts&"
export * from "./SearchContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports